import React from "react"
import MyTextareaFormField from "@common-components/fields/MyTextareaFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

export const NdfCommentSection = ({ helpers, validationSchema }: any) => {
     const isKm = helpers.values.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <MyTextareaFormField
               formikProps={helpers}
               validationSchema={validationSchema}
               name={"description"}
               label={!isKm ? <div className="required">Commentaire</div> : "Commentaire"}
               placeholder={"Commentaire..."}
               minRows={4}
               classNameLabel={"col-lg-4"}
               classNameField={"col-lg-8"}
          />
     )
}
